var slideIndex = 0;
var slideDots = 0;
try {
	showSlides(slideIndex, slideDots);
} catch (error) {}
